import { useAppSelector } from 'client/hooks/useAppSelector';

export const useAddArticlePage = () => {
  const loading = useAppSelector((state) => state.loading.loading);

  return { loading };
};
